// removed by extract-text-webpack-plugin
module.exports = {"polls-wrapper":"time-poll-list__polls-wrapper__3k6NV","no-polls-container":"time-poll-list__no-polls-container__3B17e","no-polls-wrapper":"time-poll-list__no-polls-wrapper__2qlWV","no-polls-title":"time-poll-list__no-polls-title__DHew4","no-polls-info":"time-poll-list__no-polls-info__z_lkb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/time-poll/TimePollContainer/TimePoll/TimePollList/time-poll-list.scss
// module id = 1777
// module chunks = 1